import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import axios from 'axios';
import UserProfile from './UserProfile';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { BrowserRouter as Router } from "react-router-dom";

import numeral from 'numeral';

numeral.register('locale', 'pt-br', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    currency: {
        symbol: 'R$'
    }
});
numeral.locale('pt-br');

axios.interceptors.request.use( (config) => {
    
    if(localStorage.getItem('token')) config.headers['x-access-token'] = localStorage.getItem('token');

    return config;
});

// token vencido ou inválido (ver vft-backend/routes/index.js): limpa a sessão e volta para o login
axios.interceptors.response.use(response => response, (error) => {
    if (error.response?.status === 401 && error.response.data?.code === 'invalid_token') {
        UserProfile.logout();
        window.location.assign('/login');
    }

    return Promise.reject(error);
});

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
